export const formatarMoeda = (valor) => {
  if (valor === undefined || valor === null) return 'R$ 0,00';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(valor);
};

export const formatarTimestamp = (timestamp) => {
  if (!timestamp) return '';
  const date = timestamp instanceof Date ? timestamp : new Date(timestamp);
  return date.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatarData = (data) => {
  if (!data || data === '0000-00-00') {
    return 'Não informado';
  }
  
  // Se já está no formato brasileiro (dd/mm/yyyy)
  if (data.includes('/')) {
    return data;
  }
  
  // Se está no formato ISO (yyyy-mm-dd)
  try {
    const [ano, mes, dia] = data.split('-');
    return `${dia}/${mes}/${ano}`;
  } catch {
    return data;
  }
};

